commonMethod = new function () {
    this.SortList = function (Id) {

        var list, i, switching, b, shouldSwitch;
        list = document.getElementById(Id);
        switching = true;
        /*Make a loop that will continue until
        no switching has been done:*/
        while (switching) {
            //start by saying: no switching is done:
            switching = false;
            b = list.getElementsByTagName("LI");
            //Loop through all list-items:
            for (i = 0; i < (b.length - 1) ; i++) {
                //start by saying there should be no switching:
                shouldSwitch = false;
                /*check if the next item should
                switch place with the current item:*/
                if (b[i].innerHTML.toLowerCase() > b[i + 1].innerHTML.toLowerCase()) {
                    /*if next item is alphabetically
                    lower than current item, mark as a switch
                    and break the loop:*/
                    shouldSwitch = true;
                    break;
                }
            }
            if (shouldSwitch) {
                /*If a switch has been marked, make the switch
                and mark the switch as done:*/
                b[i].parentNode.insertBefore(b[i + 1], b[i]);
                switching = true;
            }
        }

    }

    this.isNumberKey = function (evt) {
        var charCode = (evt.which) ? evt.which : event.keyCode
        if (charCode > 31 && (charCode < 48 || charCode > 57))
            return false;
        return true;
    }
    this.isFarsiKey = function (evt) {
        var charCode = (evt.which) ? evt.which : event.keyCode
        if (charCode != 8)
            if ((charCode < 1570 || charCode > 1740)) {
                return false;
            }
        return true;
    }
    this.intFormat = function (number) {
        var regex = /(\d)((\d{3},?)+)$/;
        number = number.split(',').join('');
        while (regex.test(number)) {
            number = number.replace(regex, '$1,$2');
        }
        return number;
    }
    this.numFormat = function (number) {
        var pointReg = /([\d,\.]*)\.(\d*)$/, f;
        if (pointReg.test(number)) {
            f = RegExp.$2;
            return app.commonMethod.intFormat(RegExp.$1) + '.' + f;
        }
        return app.commonMethod.intFormat(number);
    }
    this.intFormat = function (number) {
        var regex = /(\d)((\d{3},?)+)$/;
        number = number.split(',').join('');

        while (regex.test(number)) {
            number = number.replace(regex, '$1,$2');
        }
        return number;
    }
    this.changeState = function (url) {
        history.pushState(null, null, url)
    }
    this.hideToggle = function (item) {
        $("#" + item).stop();
        $("#" + item).toggle();
    }
    this.changeText_transaction = function (item) {
        if ($("#" + item).html() == '<i class="fa fa-eye"></i> جستجو') {
            $("#" + item).html('<i class="fa fa-remove"></i> بستن جستجو')
        } else {
            $("#" + item).html('<i class="fa fa-eye"></i> جستجو')
        }
    }
    var isMobileDevice = window.innerWidth < 767 ? true : false;
    this.changeTab = function (item) {
        $(item).parent().parent().find(".btntab").removeClass("btntab").addClass("btntab-default")
        $(item).parent().parent().next().find(".tab-pane").removeClass("active")
        $("div[id='" + item.id + "']").addClass("active");
        $(item).removeClass("btntab-default").addClass("btntab");
    }
    this.PrintTicket = function (id) {
        //var len = $($("#price-info fieldset")).length;

        //for (var i = 1; i <= len ; i += 2) {
        //    $($("#price-info fieldset")[i - 1]).css("width", "280px")
        //    $($("#price-info fieldset")[i]).css("width", "440px")
        //    $($("#condition-info fieldset")[i - 1]).css("width", "700px")
        //    $($("#condition-info fieldset")[i - 1]).css("height", "350px")
        //}
        app.commonMethod.Print(id);
        //for (var i = 1; i <= len ; i += 2) {
        //    $($("#price-info fieldset")[i - 1]).css("width", "320px")
        //    $($("#price-info fieldset")[i]).css("width", "497px")
        //    $($("#condition-info fieldset")[i - 1]).css("width", "100%")
        //    $($("#condition-info fieldset")[i - 1]).css("height", "inherit")
        //}
    }
    this.Print = function (id) {
        style = '<link href = "/Content/css/bootstrap.min.css" rel = "stylesheet" />' +
        '<link href = "/Content/css/bootstrap-rtl.css" rel = "stylesheet" />' +
        '<link href = "/Content/css/Style.css?ver=10" rel = "stylesheet" />' +
        '<link href = "/Content/fonts/font-awesome-4.5.0/css/font-awesome.min.css" rel = "stylesheet" />' +
        '<link href = "/Content/component/Chosen/chosen.css" rel = "stylesheet" />';
        var HTML = document.getElementById(id).innerHTML;
        var popupWin = window.open('', '_blank', 'width=960,height=600');
        popupWin.document.open();
        popupWin.document.write('<html><head>' + style + '</head><body onload="window.print()">' + HTML + '</html>');
        popupWin.document.close();
    }
    this.thousandseparator = function (number) {
        var regex = /(\d)((\d{3},?)+)$/;
        number = number.toString().split(',').join('');

        while (regex.test(number)) {
            number = number.replace(regex, '$1,$2');
        }
        return number;
    }
    this.validator = function (name) {
        if ($("form[name='" + name + "'] input.ng-invalid").length == 0) {
            return true;
        } else {
            $("form[name='" + name + "'] .ng-invalid").addClass("ng-touched")
            return false;
        }
    }
    this.inputvalidator = function (item, name) {

        if (!$(item + "[name='" + name + "']").hasClass("ng-invalid")) {
            return true;
        } else {
            $(item + "[name='" + name + "']").addClass("ng-touched")
            return false;
        }
    }
    this.NationalIdGenerator = function () {
        var nationalcode = "";
        var nb = new Array();
        nb[9] = 0;

        for (i = 0, y = 10 ; i < 9 ; i++, y--)
            nb[i] = Math.floor((Math.random() * 10)), nb[9] += (nb[i] * y);

        for (i = 0 ; i < 9 ; i++)
            nationalcode += nb[i];

        nb[9] = nb[9] - (parseInt(nb[9] / 11) * 11);

        if (nb[9] == 0 || nb[9] == 1)
            nationalcode += nb[9];
        else
            nationalcode += (11 - nb[9]);
        return nationalcode;
    }
    this.changeType = function (Id) {
        if ($("#" + Id).attr('type').toLowerCase() == 'password') {
            $("#" + Id).attr('type', 'text')
        } else {
            $("#" + Id).attr('type', 'password')
        }

    }
    this.ShowModal = function (Id) {
        $("#" + Id).modal("show");
        $(".modal-backdrop").hide();
    }
    this.HideModal = function (Id) {
        $("#" + Id).modal("hide");
    }
    this.CheckLogin = function () {

        try {
            $.ajax({
                type: "POST",
                url: '/Account/CheckLogin',
                contentType: "application/json",
                headers: {
                    'RequestVerificationToken': $("#antiForgeryToken").attr("data-token"),
                }
            }).success(function (data) {

                $.ajax({
                    type: "GET",
                    url: '/Account/GetToken',
                    contentType: "application/json",
                    headers: {
                        'RequestVerificationToken': $("#antiForgeryToken").attr("data-token"),
                    }
                }).success(function (result) {
                    $("#antiForgeryToken").attr("data-token", result.data)
                    $("#antiForgeryToken").attr("ng-init", "AntiForgeryToken='" + result.data + "'")
                });




                data = JSON.parse(data);
                if (data.Status === true) {
                    $("#myNavbar .site-icon").hide();
                    $(".login_menu").removeClass("hidden");
                    $(".menu__label").removeClass("hidden");
                    $("#login_register").addClass("hidden");
                    $("#myNavbar").css("padding", "0");
                    if (location.pathname.split('/')[1] == "available_flights") {
                        $("#requester-info-mobile").val(data.Mobile);
                        $("#requester-info-email").val(data.Email);
                        $("#requester-info-tel").val(data.Tel);
                    }
                    if (isMobileDevice) {
                        $("#identityName").html('<i class="fa fa-fw fa-user-o pull-right"></i>' + data.Name + ' <br /> ' + '<i class="fa fa-credit-card" aria-hidden="true"></i> موجودی حساب : ' + app.commonMethod.thousandseparator(data.Credit.toString()) + ' ریال' + '  <br /> ' + '<i class="fa fa-star-o" aria-hidden="true"></i> امتیاز : ' + data.Points)

                    } else {
                        $("#identityName").html('<i class="fa fa-fw fa-user-o pull-right"></i>' + data.Name + ' <br /> ' + '<i class="fa fa-credit-card" aria-hidden="true"></i> موجودی حساب : ' + app.commonMethod.thousandseparator(data.Credit.toString()) + ' ریال' + ' | ' + '<i class="fa fa-star-o" aria-hidden="true"></i> امتیاز : ' + data.Points)
                    }

                    if ($("#identityName").text() == "") {
                        $("#showpassengershistory_btn").addClass("hidden");
                        $("#getlastrequest_btn").addClass("hidden");
                    } else {
                        $("#showpassengershistory_btn").removeClass("hidden");
                        $("#getlastrequest_btn").removeClass("hidden");
                    }
                }
                else {
                    $("#menu").addClass("hidden");
                    $("#login_register").removeClass("hidden");
                }
            });
        }
        catch (e) {
            console.log(e.message)
        }
    }
    this.getPersianAl = function (value) {
        var result = '';
        switch (value) {
            case 'IR':
                result = 'ایران ایر';
                break;
            case 'W5':
                result = 'ماهان';
                break;
            case 'I3':
                result = 'آتا';
                break;
            case 'VR':
                result = 'وارش';
                break;
            case 'B9':
                result = 'ایران ایرتور';
                break;
            case 'EP':
                result = 'آسمان';
                break;
            case 'ZV':
                result = 'زاگرس';
                break;
            case 'RV':
                result = 'کاسپین';
                break;
            case 'IV':
                result = 'کاسپین';
                break;          
            case 'JI':
                result = 'معراج';
                break;
            case 'HH':
                result = 'تابان';
                break;
            default: result = '';

        }
        return result;
    }
    this.s4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
    }
    this.Guid = function () {
        return app.commonMethod.s4() + app.commonMethod.s4() + '-' + app.commonMethod.s4() + '-' + app.commonMethod.s4() + '-' +
          app.commonMethod.s4() + '-' + app.commonMethod.s4() + app.commonMethod.s4() + app.commonMethod.s4();

    }
    this.scrollToElement = function (item) {
        $('html, body').animate({
            scrollTop: $("." + item).offset().top
        }, 1500);

    }
    this.fixitem = function () {

        var wrap = $(".fix");
        $(window).on("scroll", function (e) {

            if ($(window).scrollTop() > 290) {
                wrap.addClass("fixedposition");
                $(".loaders-containershow").css("top", "150px")
            } else {
                wrap.removeClass("fixedposition");
                $(".loaders-containershow").css("top", "40px")
            }
        });
    }
    this.Required = function (value) {
        if (value == "" || value == undefined) {
            return false;
        }
        else {
            return true;
        }
    }
    this.EnglishOnKeyPress = function (e) {
        var isEnglish = isEnglishKeysPressed(e);
        var Isnumber = isNumericKeysPressedWithoutBackDel(e);
        if (!isEnglish) {
            swal("لطفاً حروف انگليسی تايپ کنيد");
            return false;
        }
        if (Isnumber) {
            swal("لطفاً حروف انگلیسی تايپ کنيد");
            return false;
        }
        return isEnglish;
    }
    this.EnglishOnKeyCode = function (KeyCode) {
        var isEnglish = isEnglishKeyCode(KeyCode);
        var Isnumber = isNumericKeysPressedWithoutBackDelKeyCode(KeyCode)
        if (!isEnglish) {
            swal("لطفاً حروف انگليسی تايپ کنيد");
            return false;
        }
        if (Isnumber) {
            swal("لطفاً حروف انگلیسی تايپ کنيد");
            return false;
        }
        return isEnglish;
    }
    this.FarsiOnKeyPress = function (e) {
        var isFarsi = isFarsiKeysPressed(e);
        var Isnumber = isNumericKeysPressedWithoutBackDel(e);
        if (!isFarsi) {
            swal("لطفاً حروف فارسی تايپ کنيد");
            return false;
        }
        if (Isnumber) {
            swal("لطفاً حروف فارسی تايپ کنيد");
            return false;
        }
        return isFarsi;
    }
    this.PersianOnKeyCode = function (KeyCode) {
        var isFarsi = isFarsiKeyCode(KeyCode);
        var Isnumber = isNumericKeysPressedWithoutBackDelKeyCode(KeyCode);
        if (!isFarsi) {
            swal("لطفاً حروف فارسی تايپ کنيد");
            return false;
        }
        if (Isnumber) {
            swal("لطفاً حروف فارسی تايپ کنيد");
            return false;
        }
        return isFarsi;
    }
    this.DateValidator = function (value) {
        return isValidDate(value);
    }
    this.NumberKeyPressed = function (e) {
        var Isnumber = isNumericKeysPressed(e);
        if (!Isnumber) {
            return false
        }
    }
    this.CheckNationalId = function (code) {

        code = code.toString();
        if (code == '0000000000' || code == '1111111111' || code == '2222222222' || code == '3333333333' || code == '4444444444' || code == '5555555555' || code == '6666666666' || code == '7777777777' || code == '8888888888' || code == '9999999999') {
            return false;
        } else {
            var L = code.length;
            if (L != 10) {
                return false;
            } else {
                if (L < 8 || parseInt(code, 10) == 0) return false;
                code = ('0000' + code).substr(L + 4 - 10);
                if (parseInt(code.substr(3, 6), 10) == 0) return false;
                var c = parseInt(code.substr(9, 1), 10);
                var s = 0;
                for (var i = 0; i < 9; i++)
                    s += parseInt(code.substr(i, 1), 10) * (10 - i);
                s = s % 11;
                return (s < 2 && c == s) || (s >= 2 && c == (11 - s));
                return true;
            }

        }
    }
    this.CheckBirthDate = function (date, AgeType) {
        
        var age;
        var _date = date.split('/');
        if (_date[0].length!=4) {
            return false;
        }
        if (_date[1].length != 2) {
            return false;
        }
        if (_date[2].length != 2) {
            return false;
        }
        if (parseInt(_date[0]) < 1800) {
            var g_date_arr = app.commonMethod.jalali_to_gregorian(Number(_date[0]), Number(_date[1]), Number(_date[2]));
            var g_date = new Date(g_date_arr[0], g_date_arr[1], g_date_arr[2]);
            age = app.commonMethod.calculateAge(g_date.getFullYear(), g_date.getMonth(), g_date.getDate());
        } else {
            age = app.commonMethod.calculateAge(_date[0], _date[1], _date[2]);
        }
     
        

        if (AgeType == 'INF') {
            if (age.years > 2) {
                return false;
            } else {
                return true;
            }
        }
        if (AgeType == 'CHD') {
            if (age.years < 2 || age.years > 12) {
                return false;
            } else {
                return true;
            }
        }
        if (AgeType == 'ADL') {
            if (age.years < 12) {
                return false;
            } else {
                return true;
            }
        }
        if (date == '') {
            return false;
        }
        var t = /^(?=.+([\/.-])..\1)(?=.{10}$)(?:(\d{4}).|)(\d\d).(\d\d)(?:.(\d{4})|)$/;
        date.replace(t, function ($, _, y, m, d, y2) {
            $ = new Date(y = y || y2, m, d);
            t = $.getFullYear() != y || $.getMonth() != m || $.getDate() != d;
        });
        return !t;
    }
    this.calculateAge = function (year, month, day) {
        var now = new Date();
        var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        var yearNow = now.getFullYear();
        var monthNow = now.getMonth();
        var dateNow = now.getDate();

        if (month == 0) {
            month = 10;
            year = year - 1;
        } else {
            month = month - 1;
        }
        var dob = new Date(year,
                           month,
                           day
                           );

        var yearDob = dob.getFullYear();
        var monthDob = dob.getMonth();
        var dateDob = dob.getDate();
        var age = {};
        var ageString = "";
        var yearString = "";
        var monthString = "";
        var dayString = "";


        yearAge = yearNow - yearDob;

        if (monthNow >= monthDob)
            var monthAge = monthNow - monthDob;
        else {
            yearAge--;
            var monthAge = 12 + monthNow - monthDob;
        }

        if (dateNow >= dateDob)
            var dateAge = dateNow - dateDob;
        else {
            monthAge--;
            var dateAge = 31 + dateNow - dateDob;

            if (monthAge < 0) {
                monthAge = 11;
                yearAge--;
            }
        }

        age = {
            years: yearAge,
            months: monthAge,
            days: dateAge
        };

        return age;
    }
    this.CheckDate = function (date) {

        if (date == '') {
            return false;
        }
        var t = /^(?=.+([\/.-])..\1)(?=.{10}$)(?:(\d{4}).|)(\d\d).(\d\d)(?:.(\d{4})|)$/;
        date.replace(t, function ($, _, y, m, d, y2) {
            $ = new Date(y = y || y2, m, d);
            t = $.getFullYear() != y || $.getMonth() != m || $.getDate() != d;
        });
        return !t;
    }
    this.Ismobile = function (value) {
        var reg = /09(0[0-9]|9[0-9]|1[0-9]|3[0-9]|2[0-9])[0-9]{7}/g;
        return reg.test(value);
    }
    this.IsEmail = function (value) {
        var reg = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        return reg.test(value);
    }
    this.IsPersian = function (value) {
        var reg = /^[\u0600-\u06FF\s]+$/;
        return reg.test(value);
    }
    this.IsEnglish = function (value) {

        var reg = /^[A-Za-z ][A-Za-z0-9 ]*$/;
        return reg.test(value);
    }
    this.CountDown = function (duration, display) {
        var timer = duration, minutes, seconds;
        setInterval(function () {
            minutes = parseInt(timer / 60, 10)
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            display.textContent = minutes + ":" + seconds;

            if (--timer <= 0) {
                timer = 0;
                return 0;
            }
        }, 1000);
    }
    this.AddCookie = function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    this.GetCookie = function (cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    this.RemoveCookie = function (cname) {
        document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
    this.Hidetopnews = function () {
        $(".topnews").addClass("hidden");
        app.commonMethod.AddCookie("topnews", '0', 7);
        $(".topnewsicon").removeClass("fa fa-window-close");
        $(".topnewsicon").addClass("fa fa-chevron-circle-down topnewsshow");
        $(".topnewsicon").attr("onclick", "app.commonMethod.Showtopnews()");
    }
    this.Showtopnews = function () {
        $(".topnews").removeClass("hidden");
        app.commonMethod.RemoveCookie("topnews");
        $(".topnewsicon").removeClass("fa fa-chevron-circle-down topnewsshow");
        $(".topnewsicon").addClass("fa fa-window-close");
        $(".topnewsicon").attr("onclick", "app.commonMethod.Hidetopnews()");
    }
    this.gregorian_to_jalali = function (gy, gm, gd) {
        g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        if (gy > 1600) {
            jy = 979;
            gy -= 1600;
        } else {
            jy = 0;
            gy -= 621;
        }
        gy2 = (gm > 2) ? (gy + 1) : gy;
        days = (365 * gy) + (parseInt((gy2 + 3) / 4)) - (parseInt((gy2 + 99) / 100)) + (parseInt((gy2 + 399) / 400)) - 80 + gd + g_d_m[gm - 1];
        jy += 33 * (parseInt(days / 12053));
        days %= 12053;
        jy += 4 * (parseInt(days / 1461));
        days %= 1461;
        if (days > 365) {
            jy += parseInt((days - 1) / 365);
            days = (days - 1) % 365;
        }
        jm = (days < 186) ? 1 + parseInt(days / 31) : 7 + parseInt((days - 186) / 30);
        jd = 1 + ((days < 186) ? (days % 31) : ((days - 186) % 30));
        return [jy, jm, jd];
    }
    this.jalali_to_gregorian = function (jy, jm, jd) {
        if (jy > 979) {
            gy = 1600;
            jy -= 979;
        } else {
            gy = 621;
        }
        days = (365 * jy) + ((parseInt(jy / 33)) * 8) + (parseInt(((jy % 33) + 3) / 4)) + 78 + jd + ((jm < 7) ? (jm - 1) * 31 : ((jm - 7) * 30) + 186);
        gy += 400 * (parseInt(days / 146097));
        days %= 146097;
        if (days > 36524) {
            gy += 100 * (parseInt(--days / 36524));
            days %= 36524;
            if (days >= 365) days++;
        }
        gy += 4 * (parseInt(days / 1461));
        days %= 1461;
        if (days > 365) {
            gy += parseInt((days - 1) / 365);
            days = (days - 1) % 365;
        }
        gd = days + 1;
        sal_a = [0, 31, ((gy % 4 == 0 && gy % 100 != 0) || (gy % 400 == 0)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        for (gm = 0; gm < 13; gm++) {
            v = sal_a[gm];
            if (gd <= v) break;
            gd -= v;
        }
        return [gy, gm, gd];
    }
    this.fv = function (year, month, day) {
        var now = new Date();
        var today = new Date(now.getYear(), now.getMonth(), now.getDate());

        var yearNow = now.getYear();
        var monthNow = now.getMonth();
        var dateNow = now.getDate();

        if (month == 0) {
            month = 10;
            year = year - 1;
        } else {
            month = month - 1;
        }
        var dob = new Date(year,
                           month,
                           day
                           );

        var yearDob = dob.getYear();
        var monthDob = dob.getMonth();
        var dateDob = dob.getDate();
        var age = {};
        var ageString = "";
        var yearString = "";
        var monthString = "";
        var dayString = "";


        yearAge = yearNow - yearDob;

        if (monthNow >= monthDob)
            var monthAge = monthNow - monthDob;
        else {
            yearAge--;
            var monthAge = 12 + monthNow - monthDob;
        }

        if (dateNow >= dateDob)
            var dateAge = dateNow - dateDob;
        else {
            monthAge--;
            var dateAge = 31 + dateNow - dateDob;

            if (monthAge < 0) {
                monthAge = 11;
                yearAge--;
            }
        }

        age = {
            years: yearAge,
            months: monthAge,
            days: dateAge
        };

        return age;
    }
}